import * as yup from 'yup';

const prizesSchema = yup.object().shape({
  prizes: yup.array().of(yup.string().required('Prize is required')),
});

export default prizesSchema;
